import { createComponent } from '@carvana/merch-components';
import classNames from 'classnames';

type OwnProps = React.PropsWithoutRef<React.HTMLProps<HTMLDivElement>> & {
  bigTag?: boolean;
  text: string;
  border?: boolean;
  bgColor: string;
  blueText?: boolean;
};

const Wrapper = createComponent('div', {
  className: 'flex w-fit items-center justify-center rounded-full'
});

const Tag = ({
  bigTag = false,
  bgColor,
  border = false,
  text,
  blueText = false,
  ...props
}: OwnProps) => (
  <Wrapper
    className={classNames(
      { 'h-24 px-16 font-bold tl-header-xs': bigTag },
      { 'h-[20px] px-8 text-[12px] font-bold leading-[18px]': !bigTag },
      { 'border border-grey-3': border },
      { 'text-white': !blueText },
      { 'text-blue-6': blueText },
      bgColor
    )}
    {...props}
  >
    {text}
  </Wrapper>
);

export default Tag;
